export default function toPatentResultURL(encodeStr, searchField) {
    if (encodeStr && searchField) {
        return '/search/result?q=' + searchField + ':"' + encodeURIComponent(encodeStr) + '"';
    } else {
        return ' ';
    }
}
